import React, { useMemo } from "react";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { AgGridReact } from "@ag-grid-community/react";

import _ from "lodash";

const MODULES = [ClientSideRowModelModule, CsvExportModule];

export const getStateOfGrid = gridRefCurrent => {
  return {
    columnState: gridRefCurrent.gridOptions.columnApi.getColumnState(),
    sortModel: gridRefCurrent.gridOptions.api.getSortModel(),
    filterModel: gridRefCurrent.gridOptions.api.getFilterModel()
  };
};

// export const saveStateOfGrid = (state, gridRefCurrent) => {
//   // console.log("saveState START");
//   if (!gridRefCurrent) {
//     return null;
//   }
//
//   const gridState = getStateOfGrid(gridRefCurrent);
//
//   if (_.size(gridState.columnState)) {
//     state.columnState = gridState.columnState;
//   }
//   if (_.size(gridState.sortModel)) {
//     state.sortModel = gridState.sortModel;
//   }
//   if (_.size(gridState.filterModel)) {
//     state.filterModel = gridState.filterModel;
//   }
//   // window.groupState = gridRefCurrent.gridOptions.columnApi.getColumnGroupState();
//   // console.log("saveState END");
// };

export const restoreStateToGrid = (stateToRestore, gridRefCurrent) => {
  // console.log("restoreState START", stateToRestore);

  stateToRestore.columnState &&
    _.size(stateToRestore.columnState) &&
    gridRefCurrent.gridOptions.columnApi.setColumnState(
      stateToRestore.columnState
    );

  stateToRestore.sortModel &&
    _.size(stateToRestore.sortModel) &&
    gridRefCurrent.gridOptions.api.setSortModel(stateToRestore.sortModel);

  stateToRestore.filterModel &&
    _.size(stateToRestore.filterModel) &&
    gridRefCurrent.gridOptions.api.setFilterModel(stateToRestore.filterModel);

  // console.log("restoreState END");
};

// const clearState = gridRefCurrent => {
//   console.log("clearState");
//   gridRefCurrent.gridOptions.columnApi.resetColumnState();
//   // gridRefCurrent.gridOptions.columnApi.resetColumnGroupState();
//   gridRefCurrent.gridOptions.api.setSortModel(null);
//   gridRefCurrent.gridOptions.api.setFilterModel(null);
// };

export function MyAgGridReact({
  gridRef,
  rowData,
  columnDefs,
  ...gridOptions
}) {
  // console.log("rerender");

  // const state = useRef({});

  //
  // useEffect(() => restoreStateToGrid(state.current, gridRef.current);
  //
  // saveStateOfGrid(state.current, gridRef.current);

  return useMemo(
    () => (
      <AgGridReact
        reactNext={true}
        ref={gridRef}
        {...gridOptions}
        rowData={rowData}
        columnDefs={columnDefs}
        modules={MODULES}
      />
    ),
    // WARNING: DO NOT PUT `gridOptions` back in this list! Produces a ton of slowness when opening up the Show/Hide columns panel
    // eslint-disable-next-line
    [rowData]
  );
}
